import React from "react";
import { Icon } from "antd";

const TENDENCIA_ESTILO = {
    up: { color: "#16a34a", icon: "arrow-up" },
    down: { color: "#dc2626", icon: "arrow-down" },
    flat: { color: "#64748b", icon: "arrow-right" },
};

export default function KpiCard(props) {
    const estiloTendencia = TENDENCIA_ESTILO[props.tendenciaDireccion] || TENDENCIA_ESTILO.flat;

    return (
        <div className="resumen-kpi-card">
            <div className="resumen-kpi-icon" style={{ backgroundColor: props.iconBackground, color: props.iconColor }}>
                <Icon type={props.icon} />
            </div>
            <div className="resumen-kpi-body">
                <div className="resumen-kpi-label">{props.label}</div>
                <div className="resumen-kpi-value">{props.value}</div>
                <div className="resumen-kpi-trend">
                    <span style={{ color: estiloTendencia.color }}>
                        <Icon type={estiloTendencia.icon} /> {props.tendenciaValor}
                    </span>
                    <span className="resumen-kpi-trend-label"> {props.tendenciaEtiqueta}</span>
                </div>
            </div>
        </div>
    );
}
